import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ImageTools from 'lib/imageTools';

import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
  card: {
    backgroundColor: '#FFF',
    boxShadow:
      '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
    padding: 10,
  },
  image: {
    maxWidth: '100%',
    objectFit: 'contain',
  },
  input: {
    display: 'none',
  },
}));

const UploadField = ({
  field: { name, value },
  form: { setFieldValue },
  label,
  type,
  fullWidth,
  disabled,
}) => {
  const classes = useStyles();

  const [file, setFile] = useState(value);

  useEffect(() => {
    if (value) {
      setFile(value.image);
    }
  }, [value]);

  const handleImageChange = ({ target }) => {
    const ImageTool = new ImageTools();
    const reader = new FileReader();
    const file = target.files[0];

    if (file) {
      reader.readAsDataURL(file);
    }

    reader.onloadend = () => {
      ImageTool.resize(file, { width: 1600, height: 1600 }, 1).then((_file) => {
        const image = URL.createObjectURL(_file);
        setFieldValue(name, { file: _file, image });
      });
    };
  };

  return (
    <div className={type === 'card' ? classes.card : ''}>
      {file && type !== 'button' && (
        <div>
          <img src={file} alt={value.file.name} className={classes.image} />
        </div>
      )}
      <input
        multiple
        name={name}
        type="file"
        accept="image/*"
        disabled={disabled}
        className={classes.input}
        id="contained-button-file"
        onChange={(e) => handleImageChange(e)}
      />
      <label htmlFor="contained-button-file">
        <Button
          color="primary"
          component="span"
          variant="contained"
          disabled={disabled}
          fullWidth={fullWidth}
        >
          {label}
        </Button>
      </label>
    </div>
  );
};

UploadField.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  field: PropTypes.shape({
    value: PropTypes.any,
    name: PropTypes.string,
  }),
};

UploadField.defaultProps = {
  type: 'button',
  required: true,
  label: 'Upload',
  fullWidth: true,
  disabled: false,
};

export default UploadField;
